<p>Your user doesn't have access! Please contact your company administrator!</p>
<button (click)="logout()">Logout</button>
